import { RootState } from 'store/root-reducer';
import { EnvironmentTypesState } from './types';
import { createSelector } from '@reduxjs/toolkit';

const selectEnvironmentTypesReducer = (state: RootState): EnvironmentTypesState => state.environmentTypes;

export const selectEnvironmentTypesIsEmpty = createSelector(
  [selectEnvironmentTypesReducer],
  (environmentTypes) => environmentTypes.environmentTypesIsEmpty
);

export const selectEnvironmentTypesLoading = createSelector(
  [selectEnvironmentTypesReducer],
  (environmentTypes) => environmentTypes.environmentTypesLoading
);

export const selectEnvironmentTypes = createSelector(
  [selectEnvironmentTypesReducer],
  (environmentTypes) => environmentTypes.environmentTypes
);
